/* src/modules/students/action_typen.js */

export const fetchStudentsTypes = [
  'FETCH_STUDENTS',
  'FETCH_STUDENTS_SUCCESS',
  'FETCH_STUDENTS_FAIL',
];

export const fetchStudentTypes = [
  'FETCH_STUDENT',
  'FETCH_STUDENT_SUCCESS',
  'FETCH_STUDENT_FAIL',
];

export const addCreditsTypes = [
  'ADD_CREDITS',
  'ADD_CREDITS_SUCCESS',
  'ADD_CREDITS_FAIL',
];

export const removeStudentTypes = [
  'REMOVE_STUDENT',
  'REMOVE_STUDENT_SUCCESS',
  'REMOVE_STUDENT_FAIL',
];

export const CLEAR_SELECTED_STUDENT = 'CLEAR_SELECTED_STUDENT';



// WEBPACK FOOTER //
// ./src/modules/students/action_types.js